module.exports = __webpack_public_path__ + "img/mktBI-code-2-min.919193ba.png";